// Dependencias generales
import React from "react";
import { useEffect } from 'react'
import InstallerInitialConfigHeader from '../../../components/InitialConfig/InstallerInitialConfigHeader';
import StepIntro from '../../../components/InitialConfig/StepIntro'
import Loader from '../../../components/Utils/Loader'
import WorkflowNavigationButtons from '../../../components/InitialConfig/WorkflowNavigationButtons'
import InstallerImg from '../../../img/dark-theme/installer.png'
import ReactGA from "react-ga4";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postInitialConfigDevicesList = endpointHelias+'/Helias/V0/Configuration/postInitialConfigDevicesList'
const updateInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/updateInstallationConfiguration"
const getHelias3pCredentials = endpointHelias+'/3rdParty/V0/Credentials/getHelias3pCredentials'
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js")
var generalCommonJS = require("../../../js/generalCommon.js")

// Initial config - Messaging
const Messaging = () => {

  useEffect(() => {    
    if(initialConfigCommonJS.antiBackOnboarding() === false){
      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("MESSAGING_INSTALLER")    
      cargarConfiguracionActualPaso()
      //comprobarEstadoRegistroMensajeria()

      if(localStorage.getItem("installationConfigurationMode") !== null){
        document.getElementById("messaging").className = "step"
        initialConfigCommonJS.visibilidadModoConfiguracion()
      }
      else{
        document.title = "HELIAS Instalador - Configuración inicial: Mensajería"
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - MENSAJERÍA', "", "")
      }  
    }

  }, []);

  function cargarConfiguracionActualPaso(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "GeneralInfo": "",
      "Meteo": "",
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": "",
      "Messaging": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{    

            //Si no hay datos configurados entonces no hago nada
  
            console.log("Información cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {  
          initialConfigCommonJS.mostrarMensajeInformativo('Se produjo un error al cargar la configuracion.',"negative")
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
  }

  function comprobarEstadoRegistroMensajeria(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID    
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getHelias3pCredentials, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
  
            var objRespuestaCuentasExistentes = jsonRespuesta.body
            
            if(objRespuestaCuentasExistentes.length > 0){ //Ya tengo aplicaciones registradas
              
              for (var i = 0; i < objRespuestaCuentasExistentes.length; i++) {
  
                if(objRespuestaCuentasExistentes[i].Aplicacion === "TELEGRAM"){
                  document.getElementById("fieldsetRegistroTelegram").style = "display: none"
                  document.getElementById("fieldsetYaRegistradoTelegram").style = "display"                  
                  document.getElementById("divTelegramTxt").innerHTML = objRespuestaCuentasExistentes[i].Usuario+', ya te tengo en mi agenda de Telegram!'
                  
                  if(localStorage.getItem("installationConfigurationMode") !== null){
                    document.getElementById("botonContinuar").className += " hidden"
                  }
                  
                }              
  
              }
            }
            
            //Si no lo tengo en la agenda dejo el formulario como está
  
            console.log("Información cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {                          
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
  }
  
  function registrarUsuarioTELEGRAM(){
  
      var usuario = document.getElementById("nombreUsuarioTelegram").value
  
      usuario = usuario.replace("@", "");
  
      if(usuario !== ""){
    
        var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
        var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
        var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  
    
        document.getElementById("loaderMessaging").className="loader overlay"

        //Registro la cuenta de TELEGRAM
        var xhttp = new XMLHttpRequest();
        xhttp.open("POST", postInitialConfigDevicesList, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify({"accountID": localStorage.getItem("accountID"), "InstallationID": ongoingInstallationConfigurationID,"Marca": "TELEGRAM","Usuario": usuario,"Contraseña": "","Token": ""});      
        xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {                
            console.log("Actualización correcta de la cuenta TELEGRAM.")          
            document.getElementById("loaderMessaging").className="loader hidden"

            document.getElementById("fieldsetRegistroTelegram").style = "display: none"
            document.getElementById("fieldsetYaRegistradoTelegram").style = "display"
            document.getElementById("divTelegramTxt").innerHTML = "¡Ya te he agregado a mi agenda!"
            document.getElementById("parrafoSaludoHelias").className = document.getElementById("parrafoSaludoHelias").className.replaceAll(" hidden", "")
          }            
          if (this.readyState === 4 && this.status !== 200) {                
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
          }            
        };
        xhttp.send(data);
      }
      else{
        document.getElementById("nombreUsuarioTelegram").className = "error"
        document.getElementById("nombreUsuarioTelegram").placeholder = "Debes introducir un ID de usuario"
      }
  
  }
  
  function guardarInformacionPaso(direccion){
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  
    
    document.getElementById("loaderMessaging").className="loader overlay"
  
    //Preparo los datos necesarios para el json
    var emailing = "false"

    if(document.getElementById("checkboxNotificacionesCriticas").checked === true){
      emailing = "true"
    }
    else{
      emailing = "false"
    }
    
    var jsonEmailing = {    
      "Emailing": emailing,
      "email": generalCommonJS.obtenerEmailUsuario()
    }
  
    var jsonGuardado = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "Messaging": jsonEmailing
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", updateInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonGuardado);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuestaGuardado = JSON.parse(this.responseText)
          if(jsonRespuestaGuardado.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            console.log("Información guardada correctamente")            
            // Y continuo a la siguiente página    
            if(localStorage.getItem("installationConfigurationMode") === null){
              if(localStorage.getItem("ongoingStepConfiguration") === "MESSAGING_INSTALLER" ){      
                initialConfigCommonJS.navegarDinamico(direccion)
              }
              else{
                initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
              }
            }
            else{
              document.getElementById("asideDetalleConfiguracion").className += " hidden"
              document.getElementById("loaderMessaging").className="loader hidden"
            }
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {                          
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);    
      
  }
  
  function navegar(direccion){    
    if(initialConfigCommonJS.existeSesion()){
      if(direccion === "continuar"){    
        if(document.getElementById("contenedorPrincipalOpcion") !== null){
          document.getElementById("contenedorPrincipalOpcion").scrollTop = 0
        }
        guardarInformacionPaso(direccion)
      }
      else{
        if(localStorage.getItem("ongoingStepConfiguration") === "MESSAGING_INSTALLER"){      
          initialConfigCommonJS.navegarDinamico(direccion)
        }
        else{
          initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
        }
      }
    }
  }

  return (          
    <main id="divMainContenedorStep">      

      <InstallerInitialConfigHeader step={"MESSAGING"}/>

      <section id="messaging" className="step wrapper">
        <div id="divContenedorStep" className="content-wrapper half">

          <StepIntro 
            Title="Mensajería" 
            Intro={<p>Si configuras reglas para alguna instalación o sucede algo importante te lo notificaré por email. No te haré spam ni te molestaré <span role="img" aria-label="Mano levantada">✋🏻</span> (lo prometo).</p>}
          /> 

          <fieldset id="fieldsetEmail">            
            <div className="message success left">
              <h1 className="title"><span className="material-icon">email</span>{generalCommonJS.obtenerEmailUsuario()}</h1>                    
            </div>
            { localStorage.getItem("installationConfigurationMode") !== null ?
              <p>Si necesitas cambiarlo, puedes hacerlo en tu cuenta de usuario pulsando <a href="/UserAccount" rel="noopener noreferrer" target="_self" className="link inline-link">aquí</a>.</p>                        
            :
              <></>
            }              
          </fieldset>

          <fieldset id="fieldsetNotificacionesCriticas" className="check multiple toggle green">
            <input type="checkbox" id="checkboxNotificacionesCriticas" defaultChecked/>
            <label className="icon-wrapper has-tooltip" htmlFor="checkboxNotificacionesCriticas" >
              <span className="label" onClick={(event) => event.preventDefault()}>
                <span>Notificaciones importantes</span>
                <span className="tooltip-trigger">
                  <span className="material-icon tooltip-icon link size-s">info</span>
                  <span className="tooltip top">
                    <span className="tooltip-container"><p className="size-m tooltip-title">Notificaciones importantes</p><p className="size-s">Deja marcada esta opción si quieres recibir automáticamente notificaciones importantes de las instalaciones de tus clientes. Si en algún momento te resultasen molestas puedes dejar de recibirlas desactivando esta opción.</p></span>
                  </span>
                </span>
              </span>
            </label>
          </fieldset>

          <fieldset className="hidden">
            <fieldset id="fieldsetRegistroTelegram">
              <fieldset className="horizontal gap-02 vertical-end">
                <fieldset className="fill">
                  <label className="has-tooltip" htmlFor="nombreUsuarioTelegram">
                    <span className="label tooltip-label">ID usuario Telegram</span>
                    <span className="tooltip-trigger">
                    <span className="material-icon tooltip-icon link size-s">info</span>
                      <span className="tooltip bottom">
                        <span className="tooltip-container">
                          <p className="size-m tooltip-title">¿Dónde encuentro mi ID de usuario Telegram?</p>
                          <p className="size-s">Para saber tu ID, abre la aplicación de Telegram y ve a Ajustes → Editar → Nombre de usuario.</p>                          
                        </span>
                      </span>
                    </span>
                  </label>

                  <input type="text" id="nombreUsuarioTelegram" onClick={() => document.getElementById("nombreUsuarioTelegram").className = ""}/>
                </fieldset>

                <button className="button primary hug" onClick={() => registrarUsuarioTELEGRAM()}>Añádeme</button>
              </fieldset>              
            </fieldset>

            <fieldset id="fieldsetYaRegistradoTelegram" style={{display: "none"}}>     

              <div id="divYaRegistradoTelegram" className="message success left">
                <h1 className="title">
                  <span className="material-icon">telegram</span>
                  <div id="divTelegramTxt" className="fill"></div>                  
                  <button className="material-icon delete link" onClick={() => initialConfigCommonJS.borrarAplicacion("TELEGRAM", "", ReactGA)}>remove_circle</button> 
                </h1>   
                
                <p id="parrafoSaludoHelias" className=" hidden">Ahora búscame en Telegram <span className="strong">(@Helias_bot)</span> y escríbeme. Me vale un simple “Hola” para reconocerte 😊, aunque puede que tarde en contestarte hasta 1 minuto. Con esto ya podré enviarte mensajes...</p>
                          
              </div>              
              
            </fieldset>
          </fieldset>

          <WorkflowNavigationButtons step={"MESSAGING"} navegar={navegar}/>

        </div>

        <Loader Id="loaderMessaging" Mensaje=""/>

        { localStorage.getItem("installationConfigurationMode") === null
          ? <picture className="main-illustration installer">
              <picture className="layer">
                <img src={InstallerImg} alt="installer"/>
              </picture>
            </picture>
          : <></>
        }  

      </section>

    </main>
    
  )
}

export default Messaging